/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCode interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCode(value) {
    if (!('RedeemPromoCodeUrl' in value) || value['RedeemPromoCodeUrl'] === undefined)
        return false;
    return true;
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCodeFromJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCodeFromJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCodeFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'RedeemPromoCodeUrl': json['redeem_promo_code_url'],
    };
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCodeToJSON(json) {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCodeToJSONTyped(json, false);
}
export function FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCodeToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'redeem_promo_code_url': value['RedeemPromoCodeUrl'],
    };
}
//# sourceMappingURL=FxIdApplicationHandlersNativeStatusNativeStatusDtoFeaturePromoCode.js.map